<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined && planIdentity!==null && planIdentity!== undefined">
    <v-dialog scrollable v-model="loading" persistent max-width="400">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <material-card
      scrollable
      :title="$t('globals.coverage')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="policy"
    >
      <!--v-dialog v-model="exportDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            {{
            $t("components.membersmanagementtable.export_history_rows")
            }}
          </v-card-title>
          <v-card-text>
            {{
            $t("components.membersmanagementtable.select_if_you_want_to_export_history_rows_too")
            }}
          </v-card-text>
          <v-card-actions>
            <v-btn color text @click="exportDialog = false">
              {{
              $t("globals.cancel")
              }}
            </v-btn>
            <v-btn color text @click="exportHistory(false)">
              {{
              $t("components.membersmanagementtable.without_history")
              }}
            </v-btn>
            <v-btn color="primary" @click="exportHistory(true)">
              {{
              $t("components.membersmanagementtable.with_history")
              }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog-->
      <v-dialog
        scrollable
        v-model="dialogs.coverage"
        persistent
        max-width="500"
      >
        <material-card
          :title="$t('views.coverage.edit_coverage_{0}', [coverageItemName])"
          icon="edit"
          :color="$vuetify.theme.themes.light.primary"
        >
          <v-card-text>
            <v-form ref="coverageForm" v-model="coverageValid">
              <v-container fluid fill-height>
                <v-row>
                  <v-col xs="12">
                    <pbas-date-picker
                      :value="effectiveDate"
                      @update-date="effectiveDate = $event"
                      :label="$t('components.inmemorydependants.effective_date')"
                      :rules="[$rules.required, $rules.firstRenewalDate]"
                      :allowedDates="allowedDates"
                      class="required"
                    ></pbas-date-picker>
                  </v-col>
                </v-row>
                <v-row v-if="coverageItem">
                  <v-col xs="12" sm="8">
                    <trans-textbox
                      v-model="coverageItem"
                      :label="$t('globals.name')"
                      :rules="[$rules.required]"
                      :disabled="!dateDependedLoaded"
                      field="Name"
                      :dialog="dialogs.coverage"
                      class="required"
                    ></trans-textbox>
                  </v-col>
                  <v-col xs="12" sm="4">
                    <no-autocomplete-textfield
                      v-model="coverageItem.Order"
                      :label="$t('globals.order')"
                      :rules="[$rules.requiredNum]"
                      class="required"
                      type="number"
                      min="0"
                    ></no-autocomplete-textfield>
                  </v-col>
                  <v-col xs="12" sm="12">
                    <trans-textarea
                      v-model="coverageItem"
                      :label="$t('globals.description')"
                      :rules="[$rules.required]"
                      :disabled="!dateDependedLoaded"
                      field="Description"
                      :dialog="dialogs.coverage"
                      class="required"
                    ></trans-textarea>
                  </v-col>
                  <v-col xs="12" sm="12">
                    <trans-select2
                      :disabled="!dateDependedLoaded"
                      ref="insuranceCarrier"
                      v-model="coverageItem"
                      propertyName="PlanInsuranceCarrier"
                      :items="insuranceCarriers"
                      :label="$t('views.coverage.covered_by')"
                      :rules="[rules.required]"
                      field="Name"
                      :displayFunc="
                        (item, str) =>
                          `${str} (${item.PolicyIdentity.Current.Number})`
                      "
                      itemValue="Id"
                      transPropertyName="InsuranceCarrier"
                    ></trans-select2>
                  </v-col>
                  <v-col xs="12" sm="12" v-if="planIdentity.TrustFund">
                    <trans-select2
                      :disabled="!dateDependedLoaded"
                      v-model="coverageItem"
                      propertyName="TrustFund"
                      :items="trustFunds"
                      :label="$t('views.coverage.covered_by')"
                      :rules="[rules.required]"
                      field="Name"
                      itemValue="Id"
                    ></trans-select2>
                  </v-col>
                  <v-col v-if="coverageClassifications && coverageClassifications.length" xs="12" sm="8">
                    <v-select
                      v-model="coverageItem.CoverageClassificationId"
                      :items="coverageClassifications"
                      item-text="Name"
                      item-value="Id"
                      :label="$t('views.coverage.classification')"
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn :disabled="saving" text @click="closeCoverage">
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn
              :disabled="!coverageValid"
              color="primary"
              :loading="saving"
              @click="tryUpdateCoverage"
            >
              {{ $t("globals.save") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>

      <v-dialog
        scrollable
        v-model="dialogs.renameCoverage"
        persistent
        max-width="500"
      >
        <material-card
          :title="$t('views.coverage.rename_coverage_{0}', [coverageItemName])"
          icon="drive_file_rename_outline"
          :color="$vuetify.theme.themes.light.primary"
        >
          <v-card-text>
            <v-form ref="renameCoverageForm" v-model="renameValid.coverage">
              <v-container fluid fill-height>
                <v-row v-if="renameCoverage">
                  <v-col xs="12" sm="8">
                    <trans-textbox
                      v-model="renameCoverage"
                      :label="$t('globals.name')"
                      :rules="[$rules.required]"
                      field="Name"
                      :dialog="dialogs.renameCoverage"
                      class="required"
                    ></trans-textbox>
                  </v-col>
                  <v-col xs="12" sm="12">
                    <trans-textarea
                      v-model="renameCoverage"
                      :label="$t('globals.description')"
                      :rules="[$rules.required]"
                      field="Description"
                      :dialog="dialogs.renameCoverage"
                      class="required"
                    ></trans-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn :disabled="saving" text @click="closeRenameCoverage">
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn
              :disabled="!renameValid.coverage"
              color="primary"
              :loading="saving"
              @click="tryRenameCoverage"
            >
              {{ $t("globals.save") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>

      <pbas-data-table
        :exporters="$exportersWithHistory"
        ref="coverageTable"
        :dataProvider="coverageProvider"
        :rowActions="coverageRowActions"
        fileNamePrefix="coverage"
        :canExpand="(item) => item.Identity.HasHistory"
        :showExpand="true"
        :generateProviderForExpanded="
          (item) => generateProvider(item, 'coverage', coverageHeaders)
        "
        identifier="coverageTable"
        @error="error = $event"
        :showSelect="false"
      ></pbas-data-table>
    </material-card>

    <material-card
      :title="$t('views.coverage.groups')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="group_work"
    >
      <v-dialog
        scrollable
        v-model="dialogs.deactivate"
        persistent
        max-width="400"
      >
        <material-card
          :title="
            $t('views.coverage.deactivate_member_group_{0}', [
              memberGroupsItemName,
            ])
          "
          icon="toggle_off"
          :color="$vuetify.theme.themes.light.error"
        >
          <v-card-text>
            <v-form ref="deactivateForm" v-model="memberGroupsValid">
              <v-container fluid grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12>
                    <pbas-date-picker
                      :value="deactivateEffectiveDate"
                      @update-date="deactivateEffectiveDate = $event"
                      :label="$t('components.inmemorydependants.effective_date')"
                      :rules="[$rules.required, $rules.firstRenewalDate]"
                      :allowedDates="allowedDates"
                      class="required"
                    ></pbas-date-picker>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              :disabled="saving"
              color
              text
              @click="
                dialogs.deactivate = false;
                effectiveDate = null;
              "
            >
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn
              :disabled="!memberGroupsValid"
              :loading="saving"
              color="error"
              text
              @click="deactivateMemberGroup"
            >
              {{ $t("globals.deactivate") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
      <v-dialog
        scrollable
        v-model="dialogs.activate"
        persistent
        max-width="400"
      >
        <material-card
          :title="
            $t('views.coverage.activate_member_group_{0}', [
              memberGroupsItemName,
            ])
          "
          icon="toggle_on"
          :color="$vuetify.theme.themes.light.success"
        >
          <v-card-text>
            <v-form ref="activateForm" v-model="memberGroupsValid">
              <v-container fluid grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12>
                    <pbas-date-picker
                      :value="activateEffectiveDate"
                      @update-date="activateEffectiveDate = $event"
                      :label="$t('components.inmemorydependants.effective_date')"
                      :rules="[$rules.required, $rules.firstRenewalDate]"
                      :allowedDates="allowedDates"
                      class="required"
                    ></pbas-date-picker>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              :disabled="saving"
              color
              text
              @click="
                dialogs.activate = false;
                effectiveDate = null;
              "
            >
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn
              :disabled="!memberGroupsValid"
              :loading="saving"
              color="success"
              text
              @click="activateMemberGroup"
            >
              {{ $t("globals.activate") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
      <v-dialog
        scrollable
        v-model="dialogs.memberGroups"
        persistent
        max-width="800"
      >
        <material-card
          :title="memberGroupsFormTitle"
          :icon="memberGroupsFormIcon"
          :color="formColor"
        >
          <v-card-text>
            <v-form ref="memberGroupsForm" v-model="memberGroupsValid">
              <v-container fluid>
                <v-row>
                  <v-col>
                    <pbas-date-picker
                      :value="effectiveDate"
                      @update-date="effectiveDate = $event"
                      :label="$t('components.inmemorydependants.effective_date')"
                      :rules="[$rules.required, $rules.firstRenewalDate]"
                      :allowedDates="allowedDates"
                      class="required"
                    ></pbas-date-picker>
                  </v-col>
                </v-row>
                <v-row v-if="memberGroupsItem">
                  <v-col xs="12" sm="8">
                    <trans-textbox
                      v-model="memberGroupsItem"
                      :label="$t('globals.name')"
                      :rules="[$rules.required]"
                      :disabled="!dateDependedLoaded"
                      field="Name"
                      :dialog="dialogs.memberGroups"
                      class="required"
                    ></trans-textbox>
                  </v-col>
                  <v-col xs="12" sm="4">
                    <no-autocomplete-textfield
                      v-model="memberGroupsItem.Order"
                      :label="$t('globals.order')"
                      :rules="[$rules.requiredNum]"
                      :disabled="!dateDependedLoaded"
                      class="required"
                      type="number"
                      min="0"
                    ></no-autocomplete-textfield>
                  </v-col>
                  <v-col xs="12" sm="12">
                    <trans-textarea
                      v-model="memberGroupsItem"
                      :label="$t('globals.description')"
                      :disabled="!dateDependedLoaded"
                      field="Description"
                      :dialog="dialogs.memberGroups"
                      :rules="[$rules.required]"
                      class="required"
                    ></trans-textarea>
                  </v-col>
                  <v-col xs="12" sm="12">
                    <trans-multi-select2
                      v-model="memberGroupsItem.CoverageIdentities"
                      :items="coverageByEffectiveDate"
                      :label="$t('globals.coverage')"
                      :rules="[$rules.atLeastOne]"
                      field="Name"
                      itemValue="Id"
                      transPropertyName="Current"
                      :disabled="!dateDependedLoaded"
                    ></trans-multi-select2>
                  </v-col>
                  <v-col xs="12" sm="6">
                    <trans-textbox
                      v-model="memberGroupsItem"
                      :label="$t('globals.kind')"
                      :rules="[$rules.required]"
                      :disabled="!dateDependedLoaded"
                      field="Kind"
                      :dialog="dialogs.memberGroups"
                      class="required"
                    ></trans-textbox>
                  </v-col>

                  <v-col xs="12" sm="6">
                    <trans-select
                      :item="memberGroupsItem"
                      propertyName="Status"
                      :items="options.Models.Status"
                      :label="$t('globals.status')"
                      :rules="[$rules.required]"
                      :disabled="!dateDependedLoaded"
                      class="required"
                    ></trans-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="closeMemberGroup">
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn
              :disabled="!memberGroupsValid"
              color="primary"
              :loading="saving"
              @click="saveMemberGroup"
            >
              {{ $t("globals.save") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
      <v-dialog
        scrollable
        v-model="dialogs.renameMemberGroup"
        persistent
        max-width="500"
      >
        <material-card
          :title="$t('views.coverage.rename_membergroup_{0}', [memberGroupsItemName])"
          icon="drive_file_rename_outline"
          :color="$vuetify.theme.themes.light.primary"
        >
          <v-card-text>
            <v-form ref="renameMemberGroupForm" v-model="renameValid.memberGroup">
              <v-container fluid fill-height>
                <v-row v-if="renameMemberGroup">
                  <v-col xs="12" sm="8">
                    <trans-textbox
                      v-model="renameMemberGroup"
                      :label="$t('globals.name')"
                      :rules="[$rules.required]"
                      field="Name"
                      :dialog="dialogs.renameMemberGroup"
                      class="required"
                    ></trans-textbox>
                  </v-col>
                  <v-col xs="12" sm="12">
                    <trans-textarea
                      v-model="renameMemberGroup"
                      :label="$t('globals.description')"
                      :rules="[$rules.required]"
                      field="Description"
                      :dialog="dialogs.renameMemberGroup"
                      class="required"
                    ></trans-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn :disabled="saving" text @click="closeRenameMemberGroup">
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn
              :disabled="!renameValid.memberGroup"
              color="primary"
              :loading="saving"
              @click="tryRenameMemberGroup"
            >
              {{ $t("globals.save") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
      <pbas-data-table
        :exporters="$exportersWithHistory"
        ref="memberGroupsTable"
        :dataProvider="memberGroupsProvider"
        :rowActions="memberGroupsRowActions"
        :floatActions="memberGroupFloatActions"
        fileNamePrefix="member-groups"
        @itemsChanged="setMemberGroups($event)"
        :canExpand="(item) => item.Identity.HasHistory"
        :showExpand="true"
        :generateProviderForExpanded="
          (item) =>
            generateProvider(item, 'memberGroups', memberGroupsHistoryHeaders)
        "
        identifier="memberGroupsTable"
        @error="error = $event"
        :showSelect="false"
      ></pbas-data-table>
    </material-card>

    <material-card
    :title="$t('Coverage Classifications')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="group_work"
    >
      <v-dialog
        scrollable
        v-model="dialogs.addCoverageClassification"
        persistent
        max-width="600"
      >
        <material-card
          :title="$t('views.coverage.add_coverage_classification')"
          icon="add"
          :color="$vuetify.theme.themes.light.success"
        >
          <v-card-text>
            <v-form ref="addCoverageClassificationForm" v-model="addCoverageClassificationValid">
              <v-container fluid>
                <v-row>
                  <v-col xs="12" sm="8">
                    <v-text-field
                      v-model="newCoverageClassification.Name"
                      :label="$t('globals.name')"
                      :rules="[$rules.required]"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col xs="12" sm="12">
                    <v-text-field
                      v-model="newCoverageClassification.Description"
                      :label="$t('globals.description')"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn :disabled="saving" text @click="closeAddCoverageClassification">
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn
              :disabled="!addCoverageClassificationValid"
              color="primary"
              :loading="saving"
              @click="tryAddCoverageClassification"
            >
              {{ $t("globals.save") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
      <v-dialog
        scrollable
        v-model="dialogs.renameCoverageClassification"
        persistent
        max-width="500"
      >
        <material-card
          :title="$t('views.coverage.edit_coverage_classification_{0}', [coverageClassificationItemName])"
          icon="edit"
        >
          <v-card-text>
            <v-form ref="renameCoverageClassificationForm" v-model="renameValid.coverageClassification">
              <v-container fluid fill-height>
                <v-row v-if="renameCoverageClassification">
                  <v-col xs="12" sm="8">
                    <trans-textbox
                      v-model="renameCoverageClassification"
                      :label="$t('globals.name')"
                      :rules="[$rules.required]"
                      field="Name"
                      :dialog="dialogs.renameCoverageClassification"
                      class="required"
                    ></trans-textbox>
                  </v-col>
                </v-row>
                <v-row v-if="renameCoverageClassification">
                  <v-col xs="12" sm="8">
                    <trans-textbox
                      v-model="renameCoverageClassification"
                      :label="$t('globals.description')"
                      field="Description"
                      :dialog="dialogs.renameCoverageClassification"
                    ></trans-textbox>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn :disabled="saving" text @click="closeRenameCoverageClassification">
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn
              :disabled="!renameValid.coverageClassification"
              color="primary"
              :loading="saving"
              @click="tryRenameCoverageClassification"
            >
              {{ $t("globals.save") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>

      <pbas-data-table
        :exporters="$exporters"
        ref="coverageClassificationTable"
        :dataProvider="coverageClassificationsProvider"
        :rowActions="coverageClassificationsRowActions"
        :floatActions="coverageClassificationFloatActions"
        fileNamePrefix="coverage-classifications"
        identifier="coverageClassificationTable"
        @error="error = $event"
        :showSelect="false"
      ></pbas-data-table>
    </material-card>

    <material-card
      :title="$t('views.coverage.coverage_configuration')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="settings_applications"
    >
      <v-dialog
        scrollable
        v-model="dialogs.coverageConfiguration"
        persistent
        max-width="500"
      >
        <material-card
        :color="$vuetify.theme.themes.light.primary"
          icon="edit"
          :title="
            $t('views.coverage.edit_coverage_configuration_{0}', [
              coverageConfiguration.Description,
            ])
          "
        >
          <v-card-text>
            <v-form
              ref="coverageConfigurationForm"
              v-model="coverageConfigurationValid"
            >
              <v-container fluid grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12>
                    <pbas-date-picker
                      :value="effectiveDate"
                      @update-date="effectiveDate = $event"
                      :label="$t('components.inmemorydependants.effective_date')"
                      :rules="[$rules.required, $rules.firstRenewalDate]"
                      :allowedDates="allowedDates"
                      class="required"
                    ></pbas-date-picker>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <trans-field
                      v-model="coverageConfiguration"
                      :label="$t('globals.description')"
                      field="Description"
                      :dialog="dialogs.memberGroups"
                    ></trans-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <currency-textfield
                      v-if="coverageConfiguration.Type === 'Amount'"
                      v-model="coverageConfigurationItem.Value"
                      :label="$t('globals.value')"
                      :rules="[$rules.requiredNum]"
                      :disabled="!dateDependedLoaded"
                      class="required"
                    />
                    <!-- <no-autocomplete-textfield
                      v-if="coverageConfiguration.Type === 'Amount'"
                      v-model="coverageConfigurationItem.Value"
                      :label="$t('globals.value')"
                      :rules="[$rules.required]"
                      :disabled="!dateDependedLoaded"
                      prefix="$"
                      @keydown="currencyKeydown"
                      @keyup="currencyKeyUp"
                      @blur="amountBlur"
                      class="required"
                    ></no-autocomplete-textfield> -->
                    <currency-textfield
                      v-else-if="coverageConfiguration.Type === 'Percentage'"
                      v-model="coverageConfigurationItem.Value"
                      :label="$t('globals.value')"
                      :rules="[$rules.requiredNum, $rules.dynamic.maxValue(100)]"
                      :disabled="!dateDependedLoaded"
                      class="required"
                      prefix="%"
                    />
                    <!-- <no-autocomplete-textfield
                      v-else-if="coverageConfiguration.Type === 'Percentage'"
                      v-model="coverageConfigurationItem.Value"
                      :label="$t('globals.value')"
                      :rules="[$rules.required]"
                      :disabled="!dateDependedLoaded"
                      prefix="%"
                      @keydown="currencyKeydown"
                      @keyup="currencyKeyUp"
                      class="required"
                    ></no-autocomplete-textfield> -->
                    <no-autocomplete-textfield
                      v-else
                      v-model="coverageConfigurationItem.Value"
                      :label="$t('globals.value')"
                      :rules="[$rules.required]"
                      :disabled="!dateDependedLoaded"
                      class="required"
                    ></no-autocomplete-textfield>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="closeCoverageConfiguration">
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn
              :disabled="!coverageConfigurationValid"
              color="primary"
              :loading="saving"
              @click="tryUpdateCoverageConfiguration"
            >
              {{ $t("globals.save") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>

      <pbas-data-table
        :exporters="$exporters"
        ref="coverageConfigurationTable"
        :dataProvider="coverageConfigurationProvider"
        :rowActions="coverageConfigurationRowActions"
        fileNamePrefix="coverageConfiguration"
        :canExpand="(item) => coverageConfigHasHistory(item)"
        :showExpand="true"
        :generateProviderForExpanded="
          (item) =>
            generateProvider(
              item,
              'configuration-parameters',
              coverageConfigurationHistoryHeaders
            )
        "
        identifier="coverageConfigurationTable"
        @error="error = $event"
        :showSelect="false"
      ></pbas-data-table>
    </material-card>
    <material-card
    :title="$t('components.plancreationwizard.calculation_formulas')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="functions"
      v-if="planIdentity.PlanType === 'HW'"
    >
      <v-card-text>
        <formulas
          :editable="false"
          :formulas.sync="formulas"
          :coverage="coverage"
          :hasAdminFees="planOptions.HasAdminFees"
          :hasContributions="planOptions.HasContributions"
          :planId="selectedPlan.Id"
          :adminFeesPerTerm="planOptions.AdminFeesPerTerm"
          :operatingFeesPerTerm="planOptions.OperatingFeesPerTerm"
          :hasEmployerContributionsPerTerm="planOptions.HasEmployerContributionsPerTerm"
          :hasFlatAdminFees="planOptions.HasPlanFlatAdminFees"
          :hasClaimAdminFees="planOptions.HasPlanClaimAdminFees"
        ></formulas>
      </v-card-text>
    </material-card>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import CoverageHeaders from "../headers/Coverage";
import MemberGroupsHeaders from "../headers/MemberGroups";
import MemberGroupsHistoryHeaders from "../headers/MemberGroupsHistory";
import CoverageConfigurationHeaders from "../headers/CoverageConfiguration";
import CoverageConfigurationHistoryHeaders from "../headers/CoverageConfigurationHistory";
import CoverageClassificationHeaders from "../headers/CoverageClassifications";
import { ODataHeader, ODataString } from "pbas-vue-components";
import TransSelect from "../components/TransSelect";
import { locker } from "../mixins/locker";
import TransTextbox from "../components/TransTextbox";
import TransField from "../components/TransField";
import TransTextarea from "../components/TransTextarea";
import TransMultiSelect2 from "../components/TransMultiSelect2";
import TransSelect2 from "../components/TransSelect2";
import { translate2 } from "../trans2";
import Formulas from "../components/Formulas";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { planSetter } from "../mixins/planSetter";
import CurrencyTextfield from '../components/CurrencyTextfield.vue';

export default {
  name: "coverage-table",
  components: {
    ErrorHandler,
    TransSelect,
    TransTextbox,
    TransTextarea,
    TransMultiSelect2,
    TransSelect2,
    TransField,
    Formulas,
    NoAutocompleteTextfield,
    CurrencyTextfield
  },
  mixins: [locker, planSetter],
  data() {
    return {
      renameMemberGroup: null,
      renameCoverage: null,
      calculationEntitiesFormulaTypes: [],
      formulas: [],
      systemTypes: ["System.Double", "System.Int32"],
      // calculationFormulaTypes: [],
      coverageParameter: null,
      renameCoverageClassification: null,
      coverageClassificationItemName: "",
      coverageClassifications: [],
      fundingMethod: null,
      valid: {
        addCoverage: false,
        coverageParameter: false,
      },
      activateEffectiveDate: null,
      deactivateEffectiveDate: null,
      rules: {
        required: () =>
          this.coverageItem.TrustFund !== null ||
          this.coverageItem.TrustFund !== undefined ||
          this.coverageItem.PlanInsuranceCarrier !== null ||
          this.coverageItem.PlanInsuranceCarrier !== undefined ||
          this.$t("validation.required"),
      },
      coverageConfigurationItemName: "",
      memberGroupsItemName: "",
      coverageItemName: "",
      coverageConfigurationHistoryHeaders: CoverageConfigurationHistoryHeaders,
      editedItemId: null,
      error: null,
      coverageConfiguration: {
        Description: "",
        Type: "",
      },
      configurationId: null,
      coverageProvider: undefined,
      memberGroupsProvider: undefined,
      coverageConfigurationProvider: undefined,
      coverageClassificationsProvider: undefined,
      editedEntity: null,
      dateDependedLoaded: false,
      effectiveDate: null,
      //exportDialog: false,
      memberGroupsPartiesCoverage: [],
      trustFunds: [],
      insuranceCarriers: [],
      saving: false,
      coverageRowActions: [
        {
          name: "editCoverage",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.editCoverage(item),
          visible: (item) => !this.selectedPlan.Current.IsTesting && !item.Identity.IsReadOnly,
        },
        {
          name: "renameCoverage",
          icon: "drive_file_rename_outline",
          title: "globals.rename",
          handler: (item) => {
            this.coverageItemName = this.trans(item, "Name");
            this.renameCoverage = JSON.parse(JSON.stringify(item));
            this.dialogs.renameCoverage = true;
            this.$nextTick(() => {
              this.$refs.renameCoverageForm.resetValidation();
            });
          },
          visible: (item) => !this.selectedPlan.Current.IsTesting && !item.Identity.IsReadOnly,
        },
      ],
      coverageClassificationsRowActions: [
        {
          name: "renameCoverageClassification",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.coverageClassificationItemName = this.trans(item, "Name");
            this.renameCoverageClassification = {
              Id: item.Id,
              Translations: [
                {
                  LanguageCode: this.language.language,
                  Name: item.Name,         // текущее значение
                  Description: item.Description  // текущее значение
                }
              ] 
            };
            this.dialogs.renameCoverageClassification = true;
            this.$nextTick(() => {
              this.$refs.renameCoverageClassificationForm.resetValidation();
            });
          },
          visible: () => !this.selectedPlan.Current.IsTesting,
        }
      ],
      coverageConfigurationRowActions: [
        {
          name: "editCoverageConfiguration",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            //console.log("edit handler: ", item);
            this.coverageConfiguration.Description = translate2(
              item,
              "Description"
            );
            this.coverageConfiguration.Type = item.ParameterType;
            return this.editCoverageConfiguration(
              item.Identity.CurrentDefaultValue,
              item.Id
            );
          },
          visible: (item) => !this.selectedPlan.Current.IsTesting,
        },
      ],
      memberGroupsRowActions: [
        {
          name: "editMemberGroup",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.editMemberGroup(item),
          visible: (item) => !this.selectedPlan.Current.IsTesting,
        },
        {
          name: "deactivateMemberGroup",
          icon: "toggle_off",
          title: "globals.deactivate",
          handler: (item) => {
            this.memberGroupsItemName = this.trans(item, "Name");
            this.memberGroupsIndex = this.memberGroups.indexOf(item);
            this.editedItemId = item.IdentityId;
            this.editedEntity = "memberGroups";
            this.dialogs.deactivate = true;
            this.$nextTick(() => {
              this.$refs.deactivateForm.resetValidation();
            });
          },
          visible: (item) =>
            !this.selectedPlan.Current.IsTesting &&
            item.Status &&
            item.Status.Name === "Active",
        },
        {
          name: "activateMemberGroup",
          icon: "toggle_on",
          title: "Activate",
          handler: (item) => {
            this.memberGroupsItemName = this.trans(item, "Name");
            this.memberGroupsIndex = this.memberGroups.indexOf(item);
            this.editedItemId = item.IdentityId;
            this.editedEntity = "memberGroups";
            this.dialogs.activate = true;
            this.$nextTick(() => {
              this.$refs.activateForm.resetValidation();
            });
          },
          visible: (item) =>
            !this.selectedPlan.Current.IsTesting &&
            item.Status &&
            item.Status.Name === "Inactive",
        },
        {
          name: "renameMemberGroup",
          icon: "drive_file_rename_outline",
          title: "globals.rename",
          handler: (item) => {
            this.memberGroupsItemName = this.trans(item, "Name");
            this.renameMemberGroup = JSON.parse(JSON.stringify(item));
            this.dialogs.renameMemberGroup = true;
            this.$nextTick(() => {
              this.$refs.renameMemberGroupForm.resetValidation();
            });
          },
          visible: () => !this.selectedPlan.Current.IsTesting,
        },
      ],
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      dialogs: {
        coverage: false,
        coverageConfiguration: false,
        memberGroups: false,
        activate: false,
        deactivate: false,
        coverageParameter: false,
        addCoverage: false,
        renameMemberGroup: false,
        renameCoverage: false,
        renameCoverageClassification: false,
        addCoverageClassification: false,
      },
      newCoverageClassification: { Name: "", Description: "" },
      addCoverageClassificationValid: false,
      coverageValid: true,
      coverageConfigurationValid: true,
      memberGroupsValid: true,
      renameValid: {
        coverage: false,
        memberGroup: false,
        coverageClassification: false,
      },
      coverage: [],
      coverageByEffectiveDate: [],
      memberGroups: [],
      coverageHeaders: [],
      coverageConfigurationHeaders: null,
      memberGroupsHeaders: MemberGroupsHeaders,
      memberGroupsHistoryHeaders: MemberGroupsHistoryHeaders,
      memberGroupsIndex: -1,
      coverageItem: null,
      coverageConfigurationItem: {},
      memberGroupsItem: null,
      defaultCoverageConfiguration: {},
      defaultMemberGroup: {
        Name: "",
        UniqueIdentifier: "",
        Translations: [],
      },
      expandHeaders: null,
      loading: false
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["options", "planIdentity", "planOptions"]),
    memberGroupFloatActions() {
      if (this.selectedPlan.Current.IsTesting) {
        return [];
      } else {
        return [
          {
            name: "addMemberGroup",
            icon: "add",
            color: this.$vuetify.theme.themes.light.success,
            text: "globals.add_new",
            handler: () => this.editMemberGroup(this.defaultMemberGroup),
          },
        ];
      }
    },
    coverageClassificationFloatActions() {
      if (this.selectedPlan.Current.IsTesting) {
        return [];
      } else {
        return [
          {
            name: "addCoverageClassification",
            icon: "add",
            color: this.$vuetify.theme.themes.light.success,
            text: "globals.add_new",
            handler: () => this.openAddCoverageClassificationDialog()
          }
        ];
      }
    },
    memberGroupsFormTitle() {
      return this.memberGroupsIndex === -1
        ? this.$t("views.coverage.create_new_group")
        : this.$t("views.coverage.edit_group_{0}", [this.memberGroupsItemName]);
    },
    memberGroupsFormIcon() {
      return this.memberGroupsIndex === -1 ? "add" : "edit";
    },
    formColor() {
      return this.memberGroupsIndex === -1 ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", ["settings"]),
    fundingMethods() {
      return this.planOptions.HasRemittances &&
        this.planOptions.HasPremiums
        ? ["Insurance Carrier", "Trust Fund"]
        : this.planOptions.HasPremiums
        ? ["Insurance Carrier"]
        : ["Trust Fund"];
    },
    activeStatus() {
      return this.options.Models.Status.filter((o) => o.Name === "Active")[0].Id;
    },
  },
  watch: {
    "coverageParameter.ConfigurationParameter.UsedInFormulaType": {
      handler(v) {
        // console.log(v);
        this.setCalculationEntity(v);
      },
      immediate: true,
    },
    "coverageParameter.ConfigurationParameter.ParameterType": {
      handler(v) {
        // console.log(v);
        if (v && v !== "Constant") {
          this.coverageParameter.ConfigurationParameter.Type = "System.Double";
        }
      },
      immediate: true,
    },
    "dialogs.coverage": {
      handler(v) {
        if (!v) this.closeCoverage();
      },
    },
    "dialogs.memberGroups": {
      handler(v) {
        if (!v) this.closeMemberGroup();
      },
    },
    "dialogs.coverageConfiguration": {
      handler(v) {
        if (!v) this.closeCoverageConfiguration();
      },
    },
    "dialogs.deactivate": {
      handler(v) {
        if (!v) this.deactivateEffectiveDate = null;
      },
    },
    "dialogs.activate": {
      handler(v) {
        if (!v) this.activateEffectiveDate = null;
      },
    },
    effectiveDate: {
      handler(v) {
        if (v) {
          this.loadDateDepended(v);
        } else {
          this.dateDependedLoaded = false;
        }
      },
    },
    deactivateEffectiveDate: {
      handler(v) {
        if (v) {
          this.loadDateDependedMemberGroup(v, "deactivate");
        } else {
          this.dateDependedLoaded = false;
        }
      },
    },
    activateEffectiveDate: {
      handler(v) {
        if (v) {
          this.loadDateDependedMemberGroup(v, "activate");
        } else {
          this.dateDependedLoaded = false;
        }
      },
    },
    "coverageItem.PlanInsuranceCarrier": {
      handler(v) {
        if (v) {
          this.coverageItem.TrustFund = null;
        }
      },
    },
    "coverageItem.TrustFund": {
      handler(v) {
        if (v) {
          this.coverageItem.PlanInsuranceCarrier = null;
        }
      },
    },
    selectedPlan: {
      handler() {
        console.log("coverage: selectedPlan changed", this.planOptions);
        if (this.planOptions !== null && this.planOptions !== undefined) {
          this.loadPlanData();
        }
      },
    },
    planIdentity: {
      handler() {
        console.log("coverage: planIdentity changed", this.planOptions);
        if (this.planOptions !== null && this.planOptions !== undefined) {
          this.loadPlanData();
        }
      },
    },
  },
  mounted() {
    console.log("coverage: mounted");
    if (this.planOptions !== null && this.planOptions !== undefined) {
      if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
        this.loadPlanData();
      }
    }
  },
  methods: {
    trans(item, field) {
      return translate2(item, field);
    },
    ...mapActions("plansMembers", [
      "updateCoverage",
      "updateCoverageConfiguration",
      "getInsuranceCarriers",
      "getTrustFunds",
      "updateMemberGroup",
      "newMemberGroup",
      "getHistory",
      "getByEffectiveDate",
      "getDropDownOptionsWithDate",
      "addCoverage",
      // "addCoverageParameter",
      "getFormulas",
      // "getCalculationEntitiesFormulaTypes",
      "renameCoverageAsync",
      "renameMemberGroupAsync",
      "addCoverageClassificationAsync",
      "renameCoverageClassificationAsync",
      "getCoverageClassificationsAsync",
      "getCoverageForFormulas"
      
    ]),
    setCalculationEntity(calculationFormulaType) {
      if (calculationFormulaType)
        this.coverageParameter.ConfigurationParameter.CalculationEntity = this.calculationEntitiesFormulaTypes[
          calculationFormulaType
        ];
    },
    openAddCoverageClassificationDialog() {
      this.newCoverageClassification = { Name: "", Description: "" };
      this.dialogs.addCoverageClassification = true;
      this.$nextTick(() => {
        if (this.$refs.addCoverageClassificationForm) {
          this.$refs.addCoverageClassificationForm.resetValidation();
        }
      });
    },
    closeRenameCoverageClassification() {
      this.dialogs.renameCoverageClassification = false;
      this.renameCoverageClassification = null;
      if (this.$refs.renameCoverageClassificationForm) {
        this.$refs.renameCoverageClassificationForm.resetValidation();
      }
    },
    closeAddCoverageClassification() {
      this.dialogs.addCoverageClassification = false;
      this.newCoverageClassification = { Name: "", Description: "" };
    },
    async tryAddCoverageClassification() {
      this.saving = true;
      console.log(this.newCoverageClassification);
      try {
        let payload = {
          Name: this.newCoverageClassification.Name,
          Description: this.newCoverageClassification.Description
        };
        await this.addCoverageClassificationAsync({
          planIdentityId: this.selectedPlan.Id,
          payload: payload,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.closeAddCoverageClassification();

        const response = await this.getCoverageClassificationsAsync({ planIdentityId: this.selectedPlan.Id });
        this.coverageClassifications = response.data.value;

        this.$refs.coverageClassificationTable.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async tryRenameCoverageClassification() {
      this.saving = true;
      try {
        const translation = this.renameCoverageClassification.Translations.find(
          t => t.LanguageCode === this.language.language
        );
        let payload = {
          Rename: {
            Name: translation ? translation.Name : "",
          Description: translation ? translation.Description : "",
          Translations: this.renameCoverageClassification.Translations.map(t => ({
            LanguageCode: t.LanguageCode,
            Name: t.Name,
            Description: t.Description
          }))
        }
        };

        console.log(payload);

        await this.renameCoverageClassificationAsync({
          planIdentityId: this.selectedPlan.Id,
          coverageClassificationId: this.renameCoverageClassification.Id,
          payload: payload
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.closeRenameCoverageClassification();
        const response = await this.getCoverageClassificationsAsync({ planIdentityId: this.selectedPlan.Id });
        this.coverageClassifications = response.data.value;
        this.$refs.coverageClassificationTable.getDataAsync();
      } catch (error) {
        console.error("Error while renaming:", error);
        this.error = error;
      }
      this.saving = false;
    },
    // filteredCoverage() {
    //   console.log(
    //     this.coverageParameter.ConfigurationParameter.UsedInFormulaType
    //   );
    //   console.log(this.coverage);
    //   switch (this.coverageParameter.ConfigurationParameter.UsedInFormulaType) {
    //     case "Premium": {
    //       return this.coverage.filter(
    //         (o) =>
    //           o.PlanInsuranceCarrier !== null &&
    //           o.PlanInsuranceCarrier !== undefined
    //       );
    //     }
    //     case "PremiumVolume": {
    //       return this.coverage.filter(
    //         (o) =>
    //           o.PlanInsuranceCarrier !== null &&
    //           o.PlanInsuranceCarrier !== undefined &&
    //           o.HasVolume
    //       );
    //     }
    //     case "PremiumTax": {
    //       return this.coverage.filter(
    //         (o) =>
    //           o.PlanInsuranceCarrier !== null &&
    //           o.PlanInsuranceCarrier !== undefined &&
    //           o.IsPremiumTaxable
    //       );
    //     }
    //     case "Remittance": {
    //       return this.coverage.filter(
    //         (o) => o.TrustFundId !== null && o.TrustFundId !== undefined
    //       );
    //     }
    //     case "RemittanceVolume": {
    //       return this.coverage.filter(
    //         (o) =>
    //           o.TrustFundId !== null &&
    //           o.TrustFundId !== undefined &&
    //           o.HasVolume
    //       );
    //     }
    //     case "RemittanceTax": {
    //       return this.coverage.filter(
    //         (o) =>
    //           o.TrustFundId !== null &&
    //           o.TrustFundId !== undefined &&
    //           o.IsRemittanceTaxable
    //       );
    //     }
    //     case "AdminFee": {
    //       return this.coverage.filter((o) => o.HasAdminFees);
    //     }
    //     case "AdminFeeTax": {
    //       return this.coverage.filter((o) => o.HasAdminFees);
    //     }
    //     default:
    //       return this.coverage;
    //   }
    // },
    closeCoverageParameter() {
      if (this.$refs.coverageParameterForm)
        this.$refs.coverageParameterForm.resetValidation();
      this.dialogs.coverageParameter = false;
      this.coverageParameter = null;
      this.$refs.coverageConfigurationTable.getDataAsync();
    },
    // amountBlur() {
    //   this.coverageConfigurationItem.Value = parseFloat(
    //     this.coverageConfigurationItem.Value
    //   ).toFixed(2);
    // },
    coverageConfigHasHistory(item) {
      return item.Identity.CurrentDefaultValueHasHistory;
    },
    allowedDates(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      const n2 = Date.parse(this.planIdentity.FirstRenewalDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    generateProvider(item, entity, headers, query) {
      let url =
        "plans/" +
        this.selectedPlan.Id +
        "/" +
        entity +
        "/" +
        item.IdentityId +
        "/history";
      if (query) {
        url += "?" + query;
      }
      return new PbasOData(
        this.$axiosHttp,
        url,
        headers.filter(
          (o) =>
            (o.visible === true && o.allowVisibilityChange === true) ||
            o.allowVisibilityChange === false
        )
      );
    },
    // isNumeric(evt) {
    //   var iKeyCode = evt.which ? evt.which : evt.keyCode;
    //   if (
    //     iKeyCode != 46 &&
    //     iKeyCode > 31 &&
    //     (iKeyCode < 48 || iKeyCode > 57) &&
    //     (iKeyCode < 96 || iKeyCode > 105)
    //   )
    //     return false;

    //   return true;
    // },
    // currencyKeyUp(evt) {
    //   var el = evt.srcElement;
    //   var value = el.value;
    //   //console.log(JSON.stringify({ v: value }));
    //   if (!value) return;
    //   var start = el.selectionStart;
    //   var end = el.selectionEnd;
    //   el.value = parseFloat(value).toFixed(2);
    //   if (start === 0 && end === 0) {
    //     end = 1;
    //   }
    //   el.setSelectionRange(start, end);
    //   //console.log("UP: ", el.value, value, start, end);
    // },
    // currencyKeydown(evt, sender) {
    //   if (evt.keyCode == 8 || evt.keyCode == 46) {
    //     //console.log("delete");
    //     return;
    //   }
    //   var el = evt.srcElement;
    //   var value = el.value;
    //   //console.log("V: ", value);
    //   if (!value) {
    //     if (evt.keyCode == 190 || evt.keyCode == 110) {
    //       el.value = value + "0.";
    //       el.setSelectionRange(2, 2);
    //     } else if (this.isNumeric(evt)) {
    //       el.value = value + ".00";
    //       el.setSelectionRange(0, 0);
    //     }
    //   } else if (parseFloat(value) && value.indexOf(".") == -1) {
    //     var start = el.selectionStart;
    //     el.value = value + ".00";
    //     el.setSelectionRange(start, start);
    //   }
    //   value = el.value;
    //   //console.log(value);
    //   if (
    //     (evt.keyCode == 190 || evt.keyCode == 110) &&
    //     value.indexOf(".") >= 0
    //   ) {
    //     el.setSelectionRange(value.indexOf(".") + 1, value.indexOf(".") + 1);
    //     evt.preventDefault();
    //     return;
    //   }
    //   //console.log(evt);

    //   if (!this.isNumeric(evt) && (evt.keyCode < 35 || evt.keyCode > 40)) {
    //     evt.preventDefault();
    //   } else if (evt.keyCode === 13) {
    //     evt.preventDefault();
    //   }
    // },
    // // eslint-disable-next-line
    // currencyKeydown(evt, sender) {
    //   if (evt.keyCode == 8 || evt.keyCode == 46) {
    //     //console.log("delete");
    //     return;
    //   }
    //   var el = evt.srcElement;
    //   var value = el.value;
    //   //console.log("V: ", value);
    //   if (!value) {
    //     if (evt.keyCode == 190 || evt.keyCode == 110) {
    //       el.value = value + "0.";
    //       el.setSelectionRange(2, 2);
    //     } /*else if (this.isNumeric(evt)) {
    //       el.value = value + ".00";
    //       el.setSelectionRange(0, 0);
    //     }*/
    //   } /*else if (parseFloat(value) && value.indexOf(".") == -1) {
    //     var start = el.selectionStart;
    //     el.value = value + ".00";
    //     el.setSelectionRange(start, start);
    //   }*/
    //   value = el.value;
    //   //console.log(value);
    //   if (
    //     (evt.keyCode == 190 || evt.keyCode == 110) &&
    //     value.indexOf(".") >= 0
    //   ) {
    //     el.setSelectionRange(value.indexOf(".") + 1, value.indexOf(".") + 1);
    //     evt.preventDefault();
    //     return;
    //   }
    //   //console.log(evt);

    //   if (
    //     evt.keyCode !== 190 &&
    //     evt.keyCode !== 110 &&
    //     !this.isNumeric(evt) &&
    //     (evt.keyCode < 35 || evt.keyCode > 40)
    //   ) {
    //     evt.preventDefault();
    //   } else if (evt.keyCode === 13) {
    //     evt.preventDefault();
    //   }
    // },
    async loadPlanData() {
      this.loading=true;
      console.log(
        "coverage: load plan data: planOptions: ",
        JSON.stringify(this.planOptions)
      );
      this.coverageHeaders = CoverageHeaders.concat([]);
      if (this.planOptions.HasPremiums) {
        this.coverageHeaders.splice(
          this.coverageHeaders.length - 1,
          0,
          new ODataHeader({
            title: "globals.insurance_carrier",
            type: new ODataString(
              "PlanInsuranceCarrier/InsuranceCarrier/Translations[]/Name",
              {
                getString: (item) => {
                  if (
                    item.PlanInsuranceCarrier === null ||
                    item.PlanInsuranceCarrier === undefined
                  )
                    return "";
                  const txt = translate2(
                    item.PlanInsuranceCarrier.InsuranceCarrier,
                    "Name"
                  );
                  if (
                    item.PlanInsuranceCarrier.PolicyIdentity &&
                    item.PlanInsuranceCarrier.PolicyIdentity.Current
                  ) {
                    return `${txt} (${
                      item.PlanInsuranceCarrier.PolicyIdentity.Current.Number
                    })`;
                  }
                  return txt;
                },
                additionalKeys: [
                  new ODataString("PlanInsuranceCarrier/InsuranceCarrier/Name"),
                ],
              }
            ),
            sortable: true,
            visible: true,
            searchable: true,
            version: 1,
            orderByKey: "PlanInsuranceCarrier/InsuranceCarrier/Name",
          })
        );
      }
      if (this.planOptions.HasRemittances) {
        this.coverageHeaders.splice(
          this.coverageHeaders.length - 1,
          0,
          new ODataHeader({
            title: "components.getreports.trust_fund",
            type: new ODataString("TrustFund/Translations[]/Name", {
              getString: (item) =>
                item.TrustFund ? translate2(item.TrustFund, "Name") : "",
            }),
            sortable: true,
            visible: true,
            searchable: true,
            version: 1,
            orderByKey: "Name",
          })
        );
      }

      this.coverageConfigurationHeaders = CoverageConfigurationHeaders;

      this.defaultMemberGroup.Status = this.options.Models.Status.filter(
        (o) => o.Name === "Active"
      )[0];

      let coverageUrl = "plans/" + this.selectedPlan.Id + "/coverage";
      let coverageConfigurationUrl =
        "plans/" + this.selectedPlan.Id + "/configuration-parameters";
      let coverageClassificationsUrl = "plans/" + this.selectedPlan.Id + "/CoverageClassifications";
      let memberGroupsUrl = "plans/" + this.selectedPlan.Id + "/memberGroups";
      this.coverageProvider = new PbasOData(
        this.$axiosHttp,
        coverageUrl,
        this.coverageHeaders
      );

      this.memberGroupsProvider = new PbasOData(
        this.$axiosHttp,
        memberGroupsUrl,
        this.memberGroupsHeaders
      );

      this.coverageConfigurationProvider = new PbasOData(
        this.$axiosHttp,
        coverageConfigurationUrl,
        this.coverageConfigurationHeaders
      );

      this.coverageClassificationsProvider = new PbasOData(
        this.$axiosHttp,
        coverageClassificationsUrl,
        CoverageClassificationHeaders
      );

      

      try {
        this.coverage = (await this.getCoverageForFormulas({planIdentityId: this.selectedPlan.Id})).data.value;
        this.coverageClassifications = (await this.getCoverageClassificationsAsync({planIdentityId: this.selectedPlan.Id})).data.value;
        this.formulas = (await this.getFormulas({
          plan: this.selectedPlan.Id,
        })).data;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    async loadDateDepended(date) {
      try {
        switch (this.editedEntity) {
          case "coverage":
            this.coverageItem = await this.lock(
              this.getByEffectiveDate,
              {
                entity: this.editedEntity,
                plan: this.selectedPlan.Id,
                id: this.editedItemId,
                date: date,
                expand:
                  "$expand=Translations,PlanInsuranceCarrier($expand=PolicyIdentity($expand=Current($select=Number)),InsuranceCarrier($select=Name)),TrustFund($expand=Translations;$select=Name,Id)",
                dialogs: this.dialogs,
                dialog: "coverage",
              },
              () => {
                this.dialogs.coverage = false;
              }
            );

            this.coverageItem.EffectiveDate = date;

            this.insuranceCarriers = (await this.getInsuranceCarriers(
              this.selectedPlan.Id
            )).data.value;
            this.trustFunds = [
              (await this.getTrustFunds(this.selectedPlan.Id)).data,
            ];

            break;
          case "memberGroups":
            if (this.memberGroupsIndex > -1) {
              this.memberGroupsItem = await this.lock(
                this.getByEffectiveDate,
                {
                  entity: this.editedEntity,
                  plan: this.selectedPlan.Id,
                  id: this.editedItemId,
                  date: date,
                  expand:
                    "$expand=Translations,CoverageIdentities($expand=Current($expand=Translations;$select=Id,Name)),Status($select=Name,Id)", //"$expand=Coverage,Status"
                  dialogs: this.dialogs,
                  dialog: "memberGroups",
                },
                () => {
                  this.dialogs.memberGroups = false;
                }
              );

              //console.log(this.memberGroupsItem);

              this.coverageByEffectiveDate = (await this.getDropDownOptionsWithDate(
                {
                  plan: this.selectedPlan.Id,
                  date: date,
                  url:
                    "coverage?$expand=Identity($expand=Current($select=Id,Name;$expand=Translations))&$select=Identity",
                }
              )).data.value.map((o) => o.Identity);
            } else {
              this.coverageByEffectiveDate = (await this.lock(
                this.getDropDownOptionsWithDate,
                {
                  plan: this.selectedPlan.Id,
                  date: date,
                  url:
                    "coverage?$expand=Identity($expand=Current($select=Id,Name;$expand=Translations))&$select=Identity",
                  dialogs: this.dialogs,
                  dialog: "memberGroups",
                },
                () => {
                  this.dialogs.memberGroups = false;
                }
              )).value.map((o) => o.Identity);
            }

            this.memberGroupsItem.EffectiveDate = date;

            break;
          case "coverage-configuration":
            this.coverageConfigurationItem = await this.lock(
              this.getByEffectiveDate,
              {
                entity: this.editedEntity,
                plan: this.selectedPlan.Id,
                id: this.editedItemId,
                date: date,
                dialogs: this.dialogs,
                dialog: "coverageConfiguration",
              },
              () => {
                this.dialogs.coverageConfiguration = false;
              }
            );

            this.coverageConfigurationItem.EffectiveDate = date;
            if (this.coverageConfiguration.Type === "Percentage")
              this.coverageConfigurationItem.Value = (
                parseFloat(this.coverageConfigurationItem.Value) * 100
              ).toFixed(2);
            else if (this.coverageConfiguration.Type === "Amount") {
              this.coverageConfigurationItem.Value = parseFloat(
                this.coverageConfigurationItem.Value
              ).toFixed(2);
            }
            break;
        }
        this.dateDependedLoaded = true;
      } catch (error) {
        this.error = error;
      }
    },
    async loadDateDependedMemberGroup(date, dialog) {
      try {
        this.memberGroupsItem = await this.lock(
          this.getByEffectiveDate,
          {
            entity: this.editedEntity,
            plan: this.selectedPlan.Id,
            id: this.editedItemId,
            date: date,
            expand:
              "$expand=Translations,CoverageIdentities($expand=Current($expand=Translations;$select=Id,Name)),Status($select=Name,Id)", //"$expand=Coverage,Status"
            dialogs: this.dialogs,
            dialog: dialog,
          },
          () => {
            this.dialogs[dialog] = false;
          }
        );

        this.memberGroupsItem.EffectiveDate = date;

        this.dateDependedLoaded = true;
      } catch (error) {
        this.error = error;
      }
    },
    editCoverage(item) {
      this.coverageItemName = this.trans(item, "Name");
      this.editedItemId = item.IdentityId;
      this.editedEntity = "coverage";
      this.dialogs.coverage = true;
      this.$nextTick(() => {
        this.$refs.coverageForm.resetValidation();
      });
    },
    editCoverageConfiguration(item, id) {
      //console.log("edit configuration: ", item, id);
      //this.coverageConfigurationItem = Object.assign({}, item);
      this.editedItemId = item.IdentityId;
      this.configurationId = id;
      this.editedEntity = "coverage-configuration";
      this.dialogs.coverageConfiguration = true;
      this.$nextTick(() => {
        this.$refs.coverageConfigurationForm.resetValidation();
      });
    },
    editMemberGroup(item) {
      this.memberGroupsItemName = this.trans(item, "Name");
      this.memberGroupsIndex = this.memberGroups.indexOf(item);
      this.editedItemId = item.IdentityId;
      this.editedEntity = "memberGroups";
      //console.log(item, this.memberGroupsItem, this.memberGroupsIndex);
      if (this.memberGroupsIndex === -1)
        this.memberGroupsItem = Object.assign({}, item);
      /*this.memberGroupsPartiesCoverage = [];
      if (this.memberGroupsItem.PartiesCoverage) {
        this.memberGroupsItem.PartiesCoverage.forEach(c => {
          this.memberGroupsPartiesCoverage.push(
            this.coverage.filter(o => o.Id === c.Coverage.Id)[0]
          );
        });
      }*/
      this.dialogs.memberGroups = true;
      this.$nextTick(() => {
        this.$refs.memberGroupsForm.resetValidation();
      });
    },
    closeCoverage() {
      this.effectiveDate = null;
      this.dialogs.coverage = false;
      this.dialogs.addCoverage = false;
      this.coverageItem = null;
      if (this.$refs.coverageForm) this.$refs.coverageForm.resetValidation();
      if (this.$refs.addCoverageForm) this.$refs.coverageForm.resetValidation();
    },
    closeRenameCoverage() {
      this.dialogs.renameCoverage = false;
      this.renameCoverage = null;
      if (this.$refs.renameCoverageForm)
        this.$refs.renameCoverageForm.resetValidation();
    },
    closeCoverageConfiguration() {
      this.effectiveDate = null;
      this.dialogs.coverageConfiguration = false;
      this.coverageConfigurationItem = Object.assign(
        {},
        this.defaultCoverageConfiguration
      );
      if (this.$refs.coverageConfigurationForm)
        this.$refs.coverageConfigurationForm.resetValidation();
    },
    closeMemberGroup() {
      this.effectiveDate = null;
      this.dialogs.memberGroups = false;
      this.memberGroupsItem = null;
      this.memberGroupsIndex = -1;
      if (this.$refs.memberGroupsForm)
        this.$refs.memberGroupsForm.resetValidation();
    },
    closeRenameMemberGroup() {
      this.dialogs.renameMemberGroup = false;
      this.renameMemberGroup = null;
      if (this.$refs.renameMemberGroupForm)
        this.$refs.renameMemberGroupForm.resetValidation();
    },
    convertToCamelCase(input) {
      return this.toCamelCase(this.toWords(input));
    },
    toWords(input) {
      var regex = /[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;

      return input.match(regex);
    },
    toCamelCase(inputArray) {
      let result = "";

      for (let i = 0, len = inputArray.length; i < len; i++) {
        let currentStr = inputArray[i];

        let tempStr = currentStr.toLowerCase();

        if (i != 0) {
          // convert first letter to upper case (the word is in lowercase)
          tempStr = tempStr.substr(0, 1).toUpperCase() + tempStr.substr(1);
        }

        result += tempStr;
      }

      return result;
    },
    // async saveCoverageParameter() {
    //   this.saving = true;
    //   let item = JSON.parse(JSON.stringify(this.coverageParameter));
    //   item.ConfigurationParameter.Name = this.coverageParameter.ConfigurationParameter.Translations.filter(
    //     (o) => o.LanguageCode === this.language.language
    //   )[0].Name;
    //   item.ConfigurationParameter.Description =
    //     item.ConfigurationParameter.Name;
    //   item.ConfigurationParameter.SystemName = this.convertToCamelCase(
    //     item.ConfigurationParameter.Name
    //   );
    //   item.ConfigurationParameterValue.SystemType =
    //     item.ConfigurationParameter.Type;
    //   if (item.ConfigurationParameter.CalculationEntity === "Contributions") {
    //     item.ConfigurationParameter.PlanIdentityId = this.selectedPlan.Id;
    //     item.ConfigurationParameter.CoverageIdentityId = null;
    //   } else {
    //     item.ConfigurationParameter.PlanIdentityId = null;
    //     if (item.ConfigurationParameter.CoverageIdentity) {
    //       item.ConfigurationParameter.CoverageIdentityId =
    //         item.ConfigurationParameter.CoverageIdentity.IdentityId;
    //       delete item.ConfigurationParameter.CoverageIdentity;
    //     }
    //   }
    //   item.ConfigurationParameterValue.EffectiveDate =
    //     item.ConfigurationParameter.EffectiveDate;

    //   if (item.ConfigurationParameter.ParameterType === "Percentage")
    //     item.ConfigurationParameterValue.Value = (
    //       item.ConfigurationParameterValue.Value / 100
    //     ).toFixed(4);
    //   try {
    //     await this.addCoverageParameter({
    //       plan: this.selectedPlan.Id,
    //       payload: item,
    //     });
    //     this.closeCoverageParameter();
    //   } catch (error) {
    //     this.error = error;
    //   }
    //   this.saving = false;
    // },
    async saveCoverageItem() {
      this.saving = true;
      let item = JSON.parse(JSON.stringify(this.coverageItem));
      if (item.PlanInsuranceCarrier) {
        item.PlanInsuranceCarrierId = item.PlanInsuranceCarrier.Id;
        delete item.PlanInsuranceCarrier;
      }
      if (item.TrustFund) {
        item.TrustFundId = item.TrustFund.Id;
        delete item.TrustFund;
      }
      if (this.fundingMethod === "Insurance Carrier") {
        item.TrustFundId = null;
      } else if (this.fundingMethod === "Trust Fund") {
        item.PlanInsuranceCarrierId = null;
      }
      item.Name = item.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Name;

      if (item.Identity) {
        item.IdentityId = item.Identity.Id;
        delete item.Identity;
      }
      delete item["@odata.context"];
      item.StatusId = this.activeStatus;
      try {
        await this.addCoverage({
          plan: this.selectedPlan.Id,
          payload: item,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.closeCoverage();
        this.$refs.memberGroupsTable.getDataAsync();
        this.$refs.coverageTable.getDataAsync();
        this.$refs.coverageConfigurationTable && this.$refs.coverageConfigurationTable.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async tryUpdateCoverage() {
      this.saving = true;
      try {
        let item = JSON.parse(JSON.stringify(this.coverageItem));
        this.coverageItem.Name = this.coverageItem.Translations.filter(
          (o) => o.LanguageCode === this.language.language
        )[0].Name;
        this.coverageItem.Translations.forEach((t) => {
          delete t.Id;
        });
        if (item.PlanInsuranceCarrier)
          item.PlanInsuranceCarrierId = item.PlanInsuranceCarrier.Id;
        else item.PlanInsuranceCarrierId = null;
        if (item.TrustFund) item.TrustFundId = item.TrustFund.Id;
        else item.TrustFundId = null;
        delete item.PlanInsuranceCarrier;
        delete item.TrustFund;
        delete item["@odata.context"];
        item.StatusId = this.activeStatus;
        await this.updateCoverage({
          plan: this.selectedPlan.Id,
          coverage: item,
          id: this.editedItemId,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.closeCoverage();
        this.$refs.memberGroupsTable.getDataAsync();
        this.$refs.coverageTable.getDataAsync();
        this.$refs.coverageConfigurationTable && this.$refs.coverageConfigurationTable.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async tryRenameCoverage() {
      this.saving = true;
      try {
        let payload = {
          Name: this.renameCoverage.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name,
          Description: this.renameCoverage.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Description,
          Translations: this.renameCoverage.Translations.map((t) => {
            return {
              LanguageCode: t.LanguageCode,
              Name: t.Name,
              Description: t.Description
            };
          }),
        };

        await this.renameCoverageAsync({
          planIdentityId: this.selectedPlan.Id,
          coverageIdentityId: this.renameCoverage.IdentityId,
          payload: payload,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.closeRenameCoverage();
        this.$refs.memberGroupsTable.getDataAsync();
        this.$refs.coverageTable.getDataAsync();
        this.$refs.coverageConfigurationTable && this.$refs.coverageConfigurationTable.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async tryUpdateCoverageConfiguration() {
      this.saving = true;
      try {
        let item = JSON.parse(JSON.stringify(this.coverageConfigurationItem));
        if (this.coverageConfiguration.Type === "Percentage")
          item.Value = (this.coverageConfigurationItem.Value / 100).toFixed(4);
        delete item["@odata.context"];
        await this.updateCoverageConfiguration({
          plan: this.selectedPlan.Id,
          parameterValue: item,
          id: this.editedItemId,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.closeCoverageConfiguration();
        this.$refs.memberGroupsTable.getDataAsync();
        this.$refs.coverageTable.getDataAsync();
        this.$refs.coverageConfigurationTable.getDataAsync();
      } catch (error) {
        this.error = error;
      }

      this.saving = false;
    },
    saveMemberGroup() {
      if (this.memberGroupsIndex > -1) {
        this.tryUpdateMemberGroup();
      } else {
        this.addMemberGroup();
      }
    },
    async tryUpdateMemberGroup() {
      this.saving = true;
      try {
        this.memberGroupsItem.Name = this.memberGroupsItem.Translations.filter(
          (o) => o.LanguageCode === this.language.language
        )[0].Name;
        this.memberGroupsItem.Description = this.memberGroupsItem.Translations.filter(
          (o) => o.LanguageCode === this.language.language
        )[0].Description;
        this.memberGroupsItem.Kind = this.memberGroupsItem.Translations.filter(
          (o) => o.LanguageCode === this.language.language
        )[0].Kind;
        this.memberGroupsItem.Translations.forEach((t) => {
          delete t.Id;
        });
        let item = JSON.parse(JSON.stringify(this.memberGroupsItem));

        if (item.Status) item.StatusId = item.Status.Id;
        else item.StatusId = null;
        delete item.Status;
        delete item["@odata.context"];
        item.CoverageIdentities = item.CoverageIdentities.filter(
          (o) => o !== null
        );
        for (let coverage of item.CoverageIdentities) {
          if (coverage) {
            delete coverage.PlanInsuranceCarrier;
            delete coverage.TrustFund;

            delete coverage.Current;
          }
        }
        await this.updateMemberGroup({
          plan: this.selectedPlan.Id,
          memberGroup: item,
          id: this.editedItemId,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.closeMemberGroup();
        this.$refs.memberGroupsTable.getDataAsync();
        this.$refs.coverageTable.getDataAsync();
        this.$refs.coverageConfigurationTable && this.$refs.coverageConfigurationTable.getDataAsync();
      } catch (error) {
        this.error = error;
      }

      this.saving = false;
    },
    async addMemberGroup() {
      this.saving = true;
      this.memberGroupsItem.Name = this.memberGroupsItem.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Name;
      this.memberGroupsItem.Description = this.memberGroupsItem.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Description;
      this.memberGroupsItem.Kind = this.memberGroupsItem.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Kind;
      let item = JSON.parse(JSON.stringify(this.memberGroupsItem));
      item.PlanId = this.selectedPlan.Id;
      item.UniqueIdentifier = item.Name;
      if (item.Status) item.StatusId = item.Status.Id;
      else item.StatusId = null;
      delete item.Status;
      // console.log(item);
      if (item.CoverageIdentities) {
        item.CoverageIdentities = item.CoverageIdentities.filter(
          (o) => o !== null
        );
        for (let coverage of item.CoverageIdentities) {
          if (coverage) {
            delete coverage.PlanInsuranceCarrier;
            delete coverage.TrustFund;

            delete coverage.Current;
          }
        }
      }

      try {
        await this.newMemberGroup({
          plan: this.selectedPlan.Id,
          memberGroup: item,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.closeMemberGroup();
        this.$refs.memberGroupsTable.getDataAsync();
        this.$refs.coverageTable.getDataAsync();
        this.$refs.coverageConfigurationTable && this.$refs.coverageConfigurationTable.getDataAsync();
      } catch (error) {
        this.error = error;
      }

      this.saving = false;
    },
    async deactivateMemberGroup() {
      this.saving = true;
      try {
        let item = JSON.parse(JSON.stringify(this.memberGroupsItem));
        item.StatusId = this.options.Models.Status.filter(
          (o) => o.Name === "Inactive"
        )[0].Id;
        delete item.Status;
        delete item["@odata.context"];
        if (item.Coverage) {
          item.Coverage.forEach((coverage) => {
            delete coverage.PlanInsuranceCarrier;
            delete coverage.TrustFund;
          });
        }

        await this.updateMemberGroup({
          plan: this.selectedPlan.Id,
          memberGroup: item,
          id: this.editedItemId,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.effectiveDate = null;
        this.dialogs.deactivate = false;
        this.$refs.memberGroupsTable.getDataAsync();
        this.$refs.coverageTable.getDataAsync();
        this.$refs.coverageConfigurationTable && this.$refs.coverageConfigurationTable.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async activateMemberGroup() {
      this.saving = true;
      try {
        let item = JSON.parse(JSON.stringify(this.memberGroupsItem));
        item.StatusId = this.options.Models.Status.filter((o) => o.Name === "Active")[0].Id;
        delete item.Status;
        delete item["@odata.context"];
        if (item.Coverage) {
          item.Coverage.forEach((coverage) => {
            delete coverage.PlanInsuranceCarrier;
            delete coverage.TrustFund;
          });
        }
        await this.updateMemberGroup({
          plan: this.selectedPlan.Id,
          memberGroup: item,
          id: this.editedItemId,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.effectiveDate = null;
        this.dialogs.activate = false;
        this.$refs.memberGroupsTable.getDataAsync();
        this.$refs.coverageTable.getDataAsync();
        this.$refs.coverageConfigurationTable && this.$refs.coverageConfigurationTable.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async tryRenameMemberGroup() {
      this.saving = true;
      try {
        let payload = {
          Name: this.renameMemberGroup.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name,
          Description: this.renameMemberGroup.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Description,
          Translations: this.renameMemberGroup.Translations.map((t) => {
            return {
              LanguageCode: t.LanguageCode,
              Name: t.Name,
              Description: t.Description
            };
          }),
        };

        await this.renameMemberGroupAsync({
          planIdentityId: this.selectedPlan.Id,
          memberGroupIdentityId: this.renameMemberGroup.IdentityId,
          payload: payload,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.closeRenameMemberGroup();
        this.$refs.memberGroupsTable.getDataAsync();
        this.$refs.coverageTable.getDataAsync();
        this.$refs.coverageConfigurationTable && this.$refs.coverageConfigurationTable.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    setMemberGroups(items) {
      this.memberGroups = items;
    },
    /*
    valueDisplayFunc(item) {
      if (item.ConfigurationParameterValues) {
        let configurationParameterValue = item.ConfigurationParameterValues.filter(
          o => o.MemberId === null
        );
        if (configurationParameterValue.length > 0) {
          let v = configurationParameterValue[0].Value;
          if (
            item.TypeDescription === "Amount"
          ) {
            var formatter = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 2
            });
            return formatter.format(v);
          } else if (item.TypeDescription === "Percentage") {
            return (parseFloat(v) * 100).toFixed(2) + "%";
          } /* else if (item.TypeDescription === "Constant") {

          } * else {
            return configurationParameterValue[0].Value;
          }
        }
      }
      return "";
    },
    */
  },
};
</script>
